import { render, staticRenderFns } from "./updaet-address.vue?vue&type=template&id=320e29a2&scoped=true"
import script from "./updaet-address.vue?vue&type=script&lang=ts"
export * from "./updaet-address.vue?vue&type=script&lang=ts"
import style0 from "./updaet-address.vue?vue&type=style&index=0&id=320e29a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320e29a2",
  null
  
)

export default component.exports